// extracted by mini-css-extract-plugin
module.exports = {"addButton":"BooksTable_addButton__3ZUS4","searchField":"BooksTable_searchField__1joNi"};